import { render, staticRenderFns } from "./EnrollmentComparisonDetailReport.vue?vue&type=template&id=19984694"
import script from "./EnrollmentComparisonDetailReport.vue?vue&type=script&lang=js"
export * from "./EnrollmentComparisonDetailReport.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentComparisonDetailReport.vue?vue&type=style&index=0&id=19984694&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports